import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

import {} from 'react-image-crop/dist/ReactCrop.css'

import './scss/app.scss'

// import 'bootstrap/dist/js/bootstrap.min.js'
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import { arrayInit } from '../src/proto'
import { installSelectGuard } from './shared/dom/select-guard'
import { installClientErrorReporter } from './shared/error/client-reporter'
import { ClientErrorBoundary } from './shared/error/client-error-boundary'

arrayInit()

// JavaScript crashes go to error tracking beside server errors (content's
// POST /api/ddd/errors/client; see client-reporter.js), and a render crash
// shows a page with a reference instead of a blank screen.
installClientErrorReporter(window)

// Every dropdown: a pick with the pointer, or a wheel, can't step a focused
// <select> on Windows (see select-guard.js).
installSelectGuard(document)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<ClientErrorBoundary><App /></ClientErrorBoundary>)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
